export default {
  LOGIN_EMAIL_PASSWORD: 'login_email_password',
  PHONE: 'phone',
  VERIFY_PHONE: 'verify_phone',
  VERIFY_EMAIL: 'verify_email',
  EMAIL_CODE: 'email_code',
  SIGNUP: 'signup',
  SIGNUP_PHONE: 'signup_phone',
  HELP: 'help',
  HELP_EMAIL: 'help_email',
  CAPTURE_EMAIL: 'capture_email',
  SUCCESS_VIEW: 'success_view',
  CELEBRATION: 'celebration',
};

export const AuthAnalyticsEvents = {
  SIGN_IN: 'sign in',
  START_SIGN_IN: 'start sign in',
  START_SIGN_UP: 'start sign up',
  SIGN_UP: 'sign up',
  START_RESET_PASSWORD: 'start reset password',
  ENTER_SMS: 'enter SMS',
  VERIFY_EMAIL: 'verify email',
};

export const SignInMethods = {
  PHONE: 'phone',
  EMAIL_PASSWORD: 'email pass',
  EMAIL_CODE: 'email code',
};

export const SmsVerificationMethods = {
  PHONE: 'phone',
  ONBOARDING: 'onboarding',
  PROFILE: 'profile',
};

export const EmailVerificationMethods = {
  EMAIL: 'email',
  ONBOARDING: 'onboarding',
};

export const AuthFlowType = {
  DEFAULT: 'default',
  VERIFY_PHONE_TO_SIGN_UP: 'verify phone to sign up',
  SIGN_UP_AND_VERIFY_PHONE: 'sign up and verify phone',
};
